export const UPDATE_SECTION = 'section/UPDATE';
export const UPDATE_SECTION_SUCCESS = 'section/UPDATE_SUCCESS';
export const UPDATE_SECTION_FAILURE = 'section/UPDATE_FAILURE';
